import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5e356e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmUpdateUserModal",
  tabindex: "-1",
  "aria-labelledby": "confirmUpdateUserModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row mx-0 bg-white mx-auto" }
const _hoisted_8 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_9 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_10 = { class: "w-max-content col-lg-3" }
const _hoisted_11 = { class: "col-lg-4" }
const _hoisted_12 = { class: "col-lg-4" }
const _hoisted_13 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_14 = { class: "w-max-content col-lg-3" }
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_18 = { class: "w-max-content col-lg-3" }
const _hoisted_19 = { class: "col-lg-4" }
const _hoisted_20 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_21 = { class: "w-max-content col-lg-3" }
const _hoisted_22 = { class: "col-lg-4" }
const _hoisted_23 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_24 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_25 = { class: "w-max-content col-lg-3" }
const _hoisted_26 = { class: "col-lg-4" }
const _hoisted_27 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_28 = { class: "w-max-content col-lg-3" }
const _hoisted_29 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_30 = {
  key: 1,
  class: "col-lg-4"
}
const _hoisted_31 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_32 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_33 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { computed, ref, watchEffect, onMounted, PropType } from 'vue'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, AUTH_STORE, COMMUNITY_STORE } from '@/store/constants'
import usersService from '@/services/users.service'
import UpdateUserComplete from '../edit-complete/index.vue'

import { Modal } from 'bootstrap'

import { PATH, PREFECTURES } from '@/constants/index'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'
import { getCookie, removeCookie } from '@/utils'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  errorUpdate: {
    type: Boolean,
  },
  handleError: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const modal = ref()

const store = useStore()
const route = useRoute()
const data = computed(() => store.getters[ACCOUNT_STORE.GETTERS.EDIT_NORMAL_DATA])
const path = route.path.split('/')[1]


const submittingButton = ref<boolean>(false)
const errorForm = ref<boolean>(false)

watchEffect(() => {
  errorForm.value = props.errorUpdate
})
const clearData = () => {
  if (getCookie(`${PATH[`${path}`].path}-required-two-factor`) === 'true') {
    removeCookie(PATH[`${path}`].header)
    removeCookie(PATH[`${path}`].pathName)
    removeCookie('invited_code')
    // removeCookie('invited_code_employee')
    localStorage.removeItem('store')
    removeCookie(`${PATH[`${path}`].path}-redirect-path`)
    removeCookie(`${PATH[`${path}`].header}-one-time`)
    removeCookie(`${PATH[`${path}`].path}-required-two-factor`)
    removeCookie(`__Secure-${PATH[`${path}`].path}_unique_user_id`)
    store.dispatch(AUTH_STORE.ACTIONS.SET_AUTH_VALUE, false)
    store.dispatch(COMMUNITY_STORE.ACTIONS.LOG_OUT)
  }
}
const onSubmit = async (): void => {
  submittingButton.value = false

  try {
    const response = await usersService.updateUserProfileApi({
      ...data.value,
      authentication_method: data.value.authentication_method === AuthenMethodTypes.EMAIL ? 2 : 1,
    })

    if (response.status === 200) {
      localStorage.removeItem('checkConfirm')
      props.handleError(false)
      submittingButton.value = false
      modal?.value?.show()
      clearData()
      return
    } else {
      // localStorage.setItem('serverError', true)
      props.handleError(true)
      window.scrollTo(0, 0)
      submittingButton.value = false
    }
  } catch (error) {
    console.log('err', error.response)
    // localStorage.setItem('serverError', true)
    submittingButton.value = false
    window.scrollTo(0, 0)
    props.handleError(true)
  }
}

onMounted(() => {
  modal.value = new Modal(document.getElementById('updateUserComplete'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('account')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeValid && _ctx.removeValid(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              class: "container pt-3 pt-lg-4 pb-3 pb-lg-5 text-break",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(translate)('SE40confirmInformation')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('nameKanji')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(data).family_name), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(data).given_name), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('nameKatakana')), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(data).family_name_kana), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(data).given_name_kana), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(data).birthday), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1)
                ]),
                _createElementVNode("h3", _hoisted_23, _toDisplayString(_unref(translate)('twoFA')), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(translate)('method')), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('useSMS') : _unref(translate)('useEmail')), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('phone') : _unref(translate)('email')), 1),
                  (_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(data).email), 1))
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(Button, {
                      title: _unref(translate)('SE40back'),
                      type: 'secondary',
                      "data-bs-dismiss": "modal",
                      onClick: _ctx.ScrollToTop
                    }, null, 8, ["title", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(Button, {
                      class: "button-submit",
                      "data-bs-dismiss": "modal",
                      title: _unref(translate)('update'),
                      type: 'secondary',
                      onClick: onSubmit,
                      disabled: submittingButton.value,
                      loading: submittingButton.value
                    }, null, 8, ["title", "disabled", "loading"])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(UpdateUserComplete)
  ], 64))
}
}

})